import { mdiCodeJson } from "@mdi/js";
import Icon from "@mdi/react";

export default function Hero() {
    return (
        <section id="hero" className="hero section dark-background hero-image">
            <div className="container ">
                <div className="row align-items-center min-vh-100 py-5">
                    {/* Coluna Direita - Imagem/Visual */}
                    <div className="col-lg-7 animate__animated animate__fadeInRight animate__faster">
                        <div className="hero-visual position-relative">
                            {/* Imagem Principal */}
                            <div className="hero-image-wrapper text-center ">
                                <img
                                    id="hero-image"
                                    src="/images/vrl_logo_horizontal_4_cinza.png"
                                    alt="Code image"
                                    className="img-fluid rounded-4 shadow-lg"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Coluna Esquerda - Conteúdo */}
                    <div className="col-lg-5 mb-5 mb-lg-0 animate__animated animate__fadeInLeft animate__faster">
                        <div className="hero-content">
                            {/* Badge */}
                            <div className="mb-4 animate__animated animate__fadeInDown animate__faster">
                                <span className="badge bg-primary bg-opacity-25 text-white px-3 py-2 rounded-pill">
                                    <Icon className="me-2" path={mdiCodeJson} size={1} /> .NET 8, React/Next.js, PHP,
                                    Angular, AWS, <Icon className="ms-2" path={mdiCodeJson} size={1} />
                                </span>
                            </div>

                            {/* Título Principal */}
                            <h1 className="fs-1 fw-bold text-white mb-4 animate__animated animate__fadeInUp animate__faster">
                                Transformamos ideias em aplicativos e sistemas prontos para crescer.
                            </h1>

                            {/* Descrição */}
                            <p className="lead text-white-50 mb-4 animate__animated animate__fadeInUp animate__faster">
                                Da ideia ao app em produção — rápido, seguro e mensurável.
                            </p>

                            {/* Botões */}
                            <div className="d-flex justify-content-start animate__animated animate__fadeInUp animate__faster">
                                <a href="#contact" className="btn btn-primary btn-lg px-4 py-3">
                                    Entrar em Contato
                                    <i className="bi bi-arrow-right ms-2"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Background Elements */}
            <div className="hero-background position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: -1 }}>
                <div
                    className="gradient-blob position-absolute"
                    style={{
                        width: "500px",
                        height: "500px",
                        background: "radial-gradient(circle, rgba(32,139,244,0.15) 0%, rgba(32,139,244,0) 70%)",
                        top: "10%",
                        left: "5%",
                        borderRadius: "50%",
                        filter: "blur(80px)"
                    }}
                ></div>
                <div
                    className="gradient-blob position-absolute"
                    style={{
                        width: "400px",
                        height: "400px",
                        background: "radial-gradient(circle, rgba(139,32,244,0.15) 0%, rgba(139,32,244,0) 70%)",
                        bottom: "20%",
                        right: "10%",
                        borderRadius: "50%",
                        filter: "blur(80px)"
                    }}
                ></div>
            </div>
        </section>
    );
}
